import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';


/**
 * Custom element that displays a variant-reactive delivery estimate.
 *
 * Listens for VariantUpdateEvent on the closest shopify-section (or dialog) and
 * morphs its own children from the freshly server-rendered section HTML,
 * mirroring the pattern used by product-price and product-inventory.
 */
class MeasurementsInfo extends Component {
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section');
    section?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section');
    section?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #handleVariantUpdate = (event) => {

    const newElement = event.detail.data.html.querySelector(
      `measurements-info[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newElement) return;

    morph(this, newElement, { childrenOnly: true });
  };
}

if (!customElements.get('measurements-info')) {
  customElements.define('measurements-info', MeasurementsInfo);
}
